export const CONFIRM_WALLET_BALANCE = "CONFIRM_WALLET_BALANCE";
export const CONFIRM_WALLET_BALANCE_SUCCESS = "CONFIRM_WALLET_BALANCE_SUCCESS";
export const CONFIRM_WALLET_BALANCE_ERROR = "CONFIRM_WALLET_BALANCE_ERROR";

export const CREATE_PLAN = "CREATE_PLAN";
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS";
export const CREATE_PLAN_ERROR = "CREATE_PLAN_ERROR";

export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_ERROR = "GET_PLANS_ERROR";

export const GET_SINGLE_PLAN = "GET_SINGLE_PLAN";
export const GET_SINGLE_PLAN_SUCCESS = "GET_SINGLE_PLAN_SUCCESS";
export const GET_SINGLE_PLAN_ERROR = "GET_SINGLE_PLAN_ERROR";

export const GET_TENOR = "GET_TENOR";
export const GET_TENOR_SUCCESS = "GET_TENOR_SUCCESS";
export const GET_TENOR_ERROR = "GET_TENOR_ERROR";

export const GET_EX_RATES = "GET_EX_RATES";
export const GET_EX_RATES_SUCCESS = "GET_EX_RATES_SUCCESS";
export const GET_EX_RATES_ERROR = "GET_EX_RATES_ERROR";

export const GET_CONTRIB_VAL = "GET_CONTRIB_VAL";
export const GET_CONTRIB_VAL_SUCCESS = "GET_CONTRIB_VAL_SUCCESS";
export const GET_CONTRIB_VAL_ERROR = "GET_CONTRIB_VAL_ERROR";

export const GET_WITHHOLDING_TAX = "GET_WITHHOLDING_TAX";
export const GET_WITHHOLDING_TAX_SUCCESS = "GET_WITHHOLDING_TAX_SUCCESS";
export const GET_WITHHOLDING_TAX_ERROR = "GET_WITHHOLDING_TAX_ERROR";

export const GET_INVESTMENT_RATES = "GET_INVESTMENT_RATES";
export const GET_INVESTMENT_RATES_SUCCESS = "GET_INVESTMENT_RATES_SUCCESS";
export const GET_INVESTMENT_RATES_ERROR = "GET_INVESTMENT_RATES_ERROR";

//Getting eligible plans for transfer
export const GET_ELIGIBLE_PLANS = "GET_ELIGIBLE_PLANS";
export const GET_ELIGIBLE_PLANS_SUCCESS = "GET_ELIGIBLE_PLANS_SUCCESS";
export const GET_ELIGIBLE_PLANS_ERROR = "GET_ELIGIBLE_PLANS_ERROR";

export const DELETE_PLAN = "DELETE_PLAN";
export const DELETE_PLAN_SUCCESS = "DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_ERROR = "DELETE_PLAN_ERROR";

export const PLAN_ACTION = "PLAN_ACTION";
export const PLAN_ACTION_SUCCESS = "PLAN_ACTION_SUCCESS";
export const PLAN_ACTION_ERROR = "PLAN_ACTION_ERROR";

export const GET_PLAN_HISTORY = "GET_PLAN_HISTORY";
export const GET_PLAN_HISTORY_SUCCESS = "GET_PLAN_HISTORY_SUCCESS";
export const GET_PLAN_HISTORY_ERROR = "GET_PLAN_HISTORY_ERROR";

export const GET_SINGLE_PLAN_HISTORY = "GET_SINGLE_PLAN_HISTORY";
export const GET_SINGLE_PLAN_HISTORY_SUCCESS = "GET_SINGLE_PLAN_HISTORY_SUCCESS";
export const GET_SINGLE_PLAN_HISTORY_ERROR = "GET_SINGLE_PLAN_HISTORY_ERROR";

export const VIEW_BANK_DETAIL = "VIEW_BANK_DETAIL";
export const VIEW_BANK_DETAIL_SUCCESS = "VIEW_BANK_DETAIL_SUCCESS";
export const VIEW_BANK_DETAIL_ERROR = "VIEW_BANK_DETAIL_ERROR";

export const GET_PENAL_CHARGE = "GET_PENAL_CHARGE";
export const GET_PENAL_CHARGE_SUCCESS = "GET_PENAL_CHARGE_SUCCESS";
export const GET_PENAL_CHARGE_ERROR = "GET_PENAL_CHARGE_ERROR";

export const PAY_WITH_CARD = "PAY_WITH_CARD";
export const PAY_WITH_CARD_SUCCESS = "PAY_WITH_CARD_SUCCESS";
export const PAY_WITH_CARD_ERROR = "PAY_WITH_CARD_ERROR";

export const COMPLETE_TRANSFER = "COMPLETE_TRANSFER";
export const COMPLETE_TRANSFER_SUCCESS = "COMPLETE_TRANSFER_SUCCESS";
export const COMPLETE_TRANSFER_ERROR = "COMPLETE_TRANSFER_ERROR";

export const GET_CLOSED_PLANS = "GET_CLOSED_PLANS";
export const GET_CLOSED_PLANS_SUCCESS = "GET_CLOSED_PLANS_SUCCESS";
export const GET_CLOSED_PLANS_ERROR = "GET_CLOSED_PLANS_ERROR";

export const UPDATE_PLAN = "UPDATE_PLAN";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_ERROR = "UPDATE_PLAN_ERROR";

export const TEST_DEBIT_CARD = "TEST_DEBIT_CARD";
export const TEST_DEBIT_CARD_SUCCESS = "TEST_DEBIT_CARD_SUCCESS";
export const TEST_DEBIT_CARD_ERROR = "TEST_DEBIT_CARD_ERROR";

export const CLEAR_NEW_PLAN = "CLEAR_NEW_PLAN";